import React , {useState, useEffect} from 'react'

import {supabase} from "../../../supabase"

import {analytics} from '../../../App'

import { 
  logEvent, 
} from "firebase/analytics";

import {
    addVocabAudiosFromLibrary,
} from '../../../queries/vocabMediaQueries'

import Grid from '@mui/material/Grid'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import AudioCardSearch from './AudioSearchCard'
import Button from '@mui/material/Button'

import { Alert, Divider, IconButton } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

import SnackAlert from '../../Dialogs/SnackAlert'

const query = `
    id,
    url
)
`

export default function AudioSearchDialog({
    confirm,
    closeConfirm,
    sourceWord,
    sourceLang, 
    targetLang,
    vocabId,
    audio,
  }){

    const [ audios, setAudio ] = useState([])
    const [ selectedAudio, setselectedAudio ] = useState([])
    const [ msgType, setMsgType ] = useState('info')
    const [ alertMsg, setAlertMsg ] = useState('')
    const [ snack, setSnack ] = useState(false)

    const handleClose = () => setSnack(false)

    const showSnack = (type, message) => {
        setSnack(true)
        setMsgType(type)
        setAlertMsg(message)
    }
  
    const selectAudio = (id) => {
        setselectedAudio([...selectedAudio, id])
    }

    const removeAudio = (id) => {
        const audiorm = selectedAudio.filter(a => a!==id)
        setselectedAudio(audiorm)
    }

    const addSelected = async () => {
        const allSel = selectedAudio.map(a => ({
            'user_vocab_id': vocabId, 
            'audio_library_id':  a,
        }))
        const count = allSel.length
        try {
            await addVocabAudiosFromLibrary(allSel)
           
            showSnack('success', 'Audio added!')
            setselectedAudio([])

            logEvent(analytics, 'add_vocab_audio', { 
                source_lang: sourceLang,
                target_lang: targetLang, 
                count: count,
                device: 'web',
            })

        } catch(error){
            showSnack('error', 'Error adding audio!')
        }
    }

    useEffect(() => {
        const controller = new AbortController();
  
        async function getAudio(){
          const { data, error } = await supabase
            .from('vocab_audio_library')
            .select(query)
            .eq('source_word', sourceWord)
            .eq('source_lang', sourceLang)
            .eq('target_lang', targetLang)
       
            if(error) {
                showSnack('error', 'Error getting audio!')
            }
            
            const audioIds = audio.map(p => p.vocab_audio_library.id)
            
            const curAudio = data.filter(a => !audioIds.includes(a.id))
      
            setAudio(curAudio)
    
        }

        getAudio()
  
        return () => {
          controller.abort();
        }

      }, [sourceWord, sourceLang, targetLang, audio]);

    return  <Dialog onClose={closeConfirm} open={confirm} >
                <DialogTitle sx={{color: '#6415ff' }}>
                    <Grid container spacing={2} justifyContent='space-between' >
                        <Grid item >
                            Image Library - {sourceWord}
                        </Grid>
                        <Grid item >
                            <IconButton onClick={closeConfirm}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid> 
                </DialogTitle>
                {audios.length>0 ?
                    <DialogContent >
                        <Grid container spacing={2} justifyContent='center' >
                            {audios.map(a => 
                                <Grid item key={a.id} >
                                    <AudioCardSearch 
                                        {...a} 
                                        vocabId={vocabId}
                                        selectAudio={selectAudio}
                                        removeAudio={removeAudio}
                                        audios={audios}
                                        selectedAudio={selectedAudio}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </DialogContent>
                :
                    <DialogContent >
                        <Alert severity="error">
                            No audio clips or all audio clips have been added for this word!
                        </Alert>
                    </DialogContent>
                }
                <Divider />
                <DialogActions>
                     <Button  
                        disabled={selectedAudio.length===0}
                        onClick={addSelected} 
                        color='primary' 
                        startIcon={<AddIcon />}
                    >
                    Add Selected
                  </Button>
                </DialogActions>
                <SnackAlert 
                    snack={snack}
                    handleClose={handleClose}
                    msgType={msgType}
                    alertMsg={alertMsg}
                />
            </Dialog>
}